<template>
  <div class="fixedtoi">
    <!-- Header réseaux sociaux + recherche -->
    <header class="d-flex align-items-center justify-content-end" style="padding-right: 50px; background-color: #c88f65; height: 50px; color: white;">
      
      <!-- Formulaire de recherche -->
      <form class="d-flex position-relative me-4" @submit.prevent>
        <input
          v-model="search"
          @input="onSearch"
          @keyup="onSearch"
          type="text"
          class="form-control"
          placeholder=""
        />

        <ul v-if="searchResults.length" class="list-group position-absolute search-results" style="top: 100%; left: 0; right: 0; z-index: 3000; max-height: 400px; min-width: 200px; overflow-y: auto;">
          <li
            v-for="result in searchResults"
            :key="result.uid"
            class="list-group-item list-group-item-action"
            @click="goToResult(result)"
          >
            <span v-if="result.type === 'animal'">🐾</span>
            <span v-if="result.type === 'news'">📰</span>
            {{ result.title }}
          </li>
        </ul>
      </form>

      <!-- Réseaux sociaux -->
      <a v-if="$seo.social.facebook" :href="$seo.social.facebook" target="_blank" style="color: white; text-decoration: none; margin-right: 30px; margin-left: 10px;">
        <i class="fab fa-facebook-f"></i>
      </a>
    </header>

    <!-- NAVBAR -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <img :src="'https://admin.asso-refuge.fr/images/' + informations.logo" :alt="informations.title" width="75" />
         {{ $seo.shortName }}
        </a>

        <button class="navbar-toggler" type="button" @click="toggleNavbar">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div :class="['collapse', 'navbar-collapse', { show: !isCollapsed }]">

          <!-- Menu -->
          <ul class="navbar-nav ms-auto">

            <!-- L'association -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">L'association</a>
              <ul class="dropdown-menu">
                <li><router-link class="dropdown-item" to="/page/22"      @click="toggleNavbar">Qui sommes-nous ?</router-link></li>
                <li><router-link class="dropdown-item" to="/page/28"      @click="toggleNavbar">Le Mastin espagnol</router-link></li>
                <li><router-link class="dropdown-item" to="/page/23"      @click="toggleNavbar">Page vétérinaire</router-link></li>
                <li><router-link class="dropdown-item" to="/page/24"      @click="toggleNavbar">Refuges partenaires</router-link></li>
              </ul>
            </li>
            <!-- À l'adoption -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">À l'adoption</a>
              <ul class="dropdown-menu">
                <li><router-link class="dropdown-item" :to="{ path: '/animaux', query: { type: 'chien' }}" @click="toggleNavbar">Chiens</router-link></li>
                <li><router-link class="dropdown-item" :to="{ path: '/animaux', query: { type: 'chiot' }}" @click="toggleNavbar">Chiots</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/page/26"      @click="toggleNavbar">Conditions d'adoption</router-link></li>
                <li><router-link class="dropdown-item" to="/page/27"      @click="toggleNavbar">Famille d'accueil</router-link></li>
              </ul>
            </li>
            <!-- Nous aider -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">Nous aider</a>
              <ul class="dropdown-menu">
                <li><router-link class="dropdown-item" to="/page/25"      @click="toggleNavbar">Comment nous aider ?</router-link></li>
                <li><router-link class="dropdown-item" to="/dons"         @click="toggleNavbar">Faire un don</router-link></li>
              </ul>
            </li>
            <li class="nav-item"><router-link class="nav-link" to="/sos"    @click="toggleNavbar">S.O.S</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/adopte" @click="toggleNavbar">Les adoptés</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/actualites" @click="toggleNavbar">Les adoptés</router-link></li>

          </ul>
        </div>
      </div>
    </nav>
  </div>

  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      informations: {},
      isCollapsed: true,
      search: '',
      animaux: [],
      news: [],
      searchResults: [],
    }
  },

  mounted() {
    const idSite = this.$idSite

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(r => r.json())
      .then(data => this.informations = data[0] || {})

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(r => r.json())
      .then(data => this.animaux = data || [])

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(r => r.json())
      .then(data => this.news = data || [])

    // Fermer dropdown quand on clique en dehors
    document.addEventListener('click', this.closeSearch)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.closeSearch)
  },

  methods: {
    toggleNavbar() {
      this.isCollapsed = !this.isCollapsed
    },

    objectContains(obj, query) {
      return Object.values(obj).some(value => {
        if (!value) return false
        if (typeof value === 'string') return value.toLowerCase().includes(query)
        if (typeof value === 'object') return this.objectContains(value, query)
        return false
      })
    },

    onSearch() {
      const q = this.search.toLowerCase().trim()

      if (!q || q.length < 2) {
        this.searchResults = []
        return
      }

      // Animaux
      const animalsResults = this.animaux
        .filter(a =>
          a.name?.toLowerCase().includes(q) ||
          a.sexe?.toLowerCase().includes(q) ||
          a.couleur?.toLowerCase().includes(q) ||
          a.race?.toLowerCase().includes(q)
        )
        .map(a => ({
          uid: 'animal-' + a.id,
          id: a.id,
          title: a.name || 'Animal',
          type: 'animal'
        }))

      // Actualités
      const newsResults = this.news
        .filter(n => this.objectContains(n, q))
        .map(n => ({
          uid: 'news-' + n.id,
          id: n.id,
          title: n.nom || 'Actualité',
          type: 'news'
        }))

      this.searchResults = [...animalsResults, ...newsResults].slice(0, 10)
    },

    goToResult(result) {
      this.search = ''
      this.searchResults = []

      if (result.type === 'animal') this.$router.push(`/animaux/${result.id}`)
      if (result.type === 'news') this.$router.push(`/publication/${result.id}`)

      this.isCollapsed = true
    },

    closeSearch(e) {
      if (!e.target.closest('form')) this.searchResults = []
    }
  }
}
</script>

<style src="../assets/css/refonte.css"></style>
